import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { setAccent, ToastProvider } from '@theonefamily/ui';
import { ErrorBoundary } from './components/ErrorBoundary';
import App from './App';
import './index.css';

// Bridge accent: violet — connection/integration
setAccent('#8b5cf6');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <BrowserRouter basename="/bridge">
          <App />
        </BrowserRouter>
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
